import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Alert, Box, Button, Card, CardContent, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useRestartOnboarding } from '../layout/hooks/useOnboarding'
import { useUserDetails } from '../user/hooks/user.hooks'

const HomePage = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const userDetails = useUserDetails()
  const restartOnboarding = useRestartOnboarding()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        backgroundColor: theme.palette.background.default,
        padding: 3,
      }}
    >
      <Card
        elevation={3}
        sx={{
          maxWidth: 600,
          width: '100%',
          borderTop: `4px solid ${theme.palette.primary.main}`,
        }}
      >
        <CardContent sx={{ padding: 4 }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: 600,
              mb: 2,
            }}
          >
            {t('home.welcome', { name: userDetails?.fullName })}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: theme.palette.secondary.main,
              mb: 3,
              lineHeight: 1.6,
            }}
          >
            {t('home.description')}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              padding: 2,
              backgroundColor: 'rgba(253, 209, 6, 0.1)',
              borderRadius: 1,
              borderLeft: `3px solid ${theme.palette.primary.main}`,
            }}
          >
            <ArrowBackIcon
              sx={{
                color: theme.palette.primary.main,
                fontSize: '2rem',
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.secondary.main,
                fontWeight: 500,
              }}
            >
              {t('home.selectFromSidebar')}
            </Typography>
          </Box>
        </CardContent>
      </Card>

      <Alert
        severity="info"
        sx={{ maxWidth: 600, width: '100%', mt: 2 }}
        action={
          <Button color="inherit" size="small" onClick={restartOnboarding}>
            {t('home.restartOnboardingAction')}
          </Button>
        }
      >
        {t('home.restartOnboarding')}
      </Alert>
    </Box>
  )
}

export default HomePage
